import chart1 from "./images/chart1.jpg";
import chart2 from "./images/chart2.jpg";
import example1 from "./images/example_1.jpg";
import example2 from "./images/example_2.jpg";
import example3 from "./images/example_3.jpg";
import example4 from "./images/example_4.jpg";
import example5 from "./images/example_5.jpg";

const data = [
  {
    title: "Title 1",
    description: " Lorem ipsum, Eveniet, provident quaerat?",
    imgSrc: example1,
    imgAlt: "data chart example 1",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi necessitatibus reiciendis quod?",
  },
  {
    title: "Title 2",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example2,
    imgAlt: "data chart example 2",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 3",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example3,
    imgAlt: "data chart example 3",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 4",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example4,
    imgAlt: "data chart example 4",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 5",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example5,
    imgAlt: "data chart example 5",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 6",
    description: " Lorem ipsum,provident quaerat?",
    imgSrc: example1,
    imgAlt: "data chart example 1",
    addedInfo: "Ipsam deserunt alias, necessitatibus reiciendis quod?",
  },
  {
    title: "Title 7",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example2,
    imgAlt: "data chart example 2",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 8",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example3,
    imgAlt: "data chart example 3",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 9",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example4,
    imgAlt: "data chart example 4",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 10",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example5,
    imgAlt: "data chart example 5",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 11",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example1,
    imgAlt: "data chart example 1",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 12",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example2,
    imgAlt: "data chart example 2",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 13",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example3,
    imgAlt: "data chart example 3",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 14",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example4,
    imgAlt: "data chart example 4",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 15",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example5,
    imgAlt: "data chart example 5",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 16",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example1,
    imgAlt: "data chart example 1",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 17",
    description: " Lorem ipsum, dolor sit , provident quaerat?",
    imgSrc: example2,
    imgAlt: "data chart example 2",
    addedInfo: "Ipsam deserunt alias, nihiitatibus reiciendis quod?",
  },
  {
    title: "Title 18",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example3,
    imgAlt: "data chart example 3",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 19",
    description:
      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eveniet, provident quaerat?",
    imgSrc: example4,
    imgAlt: "data chart example 4",
    addedInfo:
      "Ipsam deserunt alias, nihil vel excepturi voluptatem expedita necessitatibus reiciendis quod?",
  },
  {
    title: "Title 20",
    description: " Lorem provident quaerat?",
    imgSrc: example5,
    imgAlt: "data chart example 5",
    addedInfo: "Ipsam necessitatibus reiciendis quod?",
  },
];

export { data };
